var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:({ backgroundColor: _vm.bg })},[_c('div',{staticClass:"card-details"},[_vm._t("card-details")],2),_c('div',{staticClass:"more-details"},[_vm._t("card-footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }